export const endpoints = {
    auth_change_password: "auth/change-password",
    user: "user",
    user_role: "user/role",
    user_change_password: "user/change-password",
    company: "company",
    company_type: "company/type",
    company_specialty: "company/specialty",
    company_officer: "company/officer",
    company_customer: "company/customer",
    company_domain: "company/domain",
    ecommerce_product: "product",
    ecommerce_product_price: "product/:productId/price",
    ecommerce_product_module: "product/:productId/module",
    ecommerce_product_resource: "product/:productId/resource",
    ecommerce_product_dependency: "product/:productId/dependency",
    ecommerce_product_upgrade_path: "product/:productId/upgrade-path",
    ecommerce_promotion: "promotion",
    ecommerce_subscription: "subscription",
    ecommerce_subscription_activate: "subscription/:id/activate",
    ecommerce_subscription_cancel: "subscription/:id/cancel",
    ecommerce_subscription_suspend: "subscription/:id/suspend",
    ecommerce_subscription_resume: "subscription/:id/resume",
    ecommerce_subscription_extend: "subscription/:id/extend",
    ecommerce_checkout: "checkout",
    ecommerce_checkout_confirm: "checkout/:id/confirm",
    ecommerce_checkout_cancel: "checkout/:id/cancel",
    ecommerce_checkout_request_refund: "checkout/:id/request-refund",
    ecommerce_checkout_process_refund: "checkout/:id/process-refund",
    ecommerce_checkout_note: "checkout/:checkoutOrderId/note",
    ecommerce_payment_method: "payment-method",
    module: "module",
    module_assignment: "module/assignment",
    module_kind: "module/kind",
    module_note: "module/note",
    module_note_trash: "module/note/trash",
    module_note_trash_restore: "module/note/trash/:id/restore",
    module_note_trash_delete: "module/note/trash/:id",
    module_note_pin: "module/note/pin",
    module_note_reminder: "module/note/reminder",
    module_note_category: "module/note/category",
    module_note_category_tree: "module/note/category/tree",
    module_note_tag: "module/note/tag",
    module_agenda: "module/agenda",
    module_agenda_status: "module/agenda/:id/status",
    user_config: "user-config",
    spotlight_search: "spotlight/search",
    vehicle_brand: "vehicle/brand",
    vehicle_brand_model: "vehicle/brand/%d/model",
    vehicle_brand_model_search: "vehicle/brand/model/search",
    vehicle_year: "vehicle/year",
    stock_unit: "@common/stock/unit",
    currency: "@common/localization/currency",
    weather_lookup: "@common/module/weather/lookup",
    weather_location_search: "@common/module/weather/location/search",
    upload: "upload",
    upload_attach_batch: "upload/attach/batch",
    upload_detach_batch: "upload/detach/batch",
    upload_sync_batch: "upload/sync/batch",
    upload_batch_delete: "upload/batch/delete",
    file_manager_entities: "file-manager/entities",
    file_manager_entity_check: "file-manager/entity-check",
    file_manager_folder: "file-manager/folder",
    file_manager_folder_batch: "file-manager/folder/batch/update",
    file_manager_folder_batch_delete: "file-manager/folder/batch/delete",
    file_manager_folder_tree: "file-manager/folder/tree",
    file_manager_file: "file-manager/file",
    file_manager_file_batch: "file-manager/file/batch/update",
    file_manager_trash: "file-manager/trash",
    file_manager_trash_folder: "file-manager/trash/folder",
    module_music_library: "module/music/library",
    module_music_playlist: "module/music/playlist",
}
